import { PRESET_THEME } from '../models/enums/PresetTheme.enum';

export default [
  {
    id: 'default',
    theme: PRESET_THEME.Aura,
    label: 'Default',
  },
  {
    id: 'colorful',
    theme: PRESET_THEME.Material,
    label: 'Colorful',
  },
  {
    id: 'bw',
    theme: PRESET_THEME.Nora,
    label: 'BW',
  },
];
